import React, { useState } from "react";
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
    Collapse,
    Divider,
} from "@mui/material";

import {
    MdDashboard,
    MdShoppingBag,
    MdShoppingCart,
    MdPeople,
    MdSettings,
    MdExpandMore,
    MdExpandLess,
    MdAdd,
    MdList,
} from "react-icons/md";

import { IoMdMail } from "react-icons/io";

import { Link, useLocation } from "react-router-dom";

import Logo from "../../assets/logoazul.png";

export default function Sidebar() {
    const location = useLocation();

    // controla submenu
    const [openProducts, setOpenProducts] = useState(false);

    const isActive = (path) => location.pathname === path;

    return (
        <Box
            sx={{
                width: 260,
                background: "#ffffff",
                height: "100vh",
                borderRight: "1px solid #f1f1f1",
                p: 2,
                display: "flex",
                position: "fixed",
                flexDirection: "column",
            }}
        >
            {/* LOGO */}
            <Box sx={{ mb: 3, px: 1 }}>
                <img src={Logo} alt="logo" style={{ width: 150, marginBottom: 20 }} />
            </Box>

            {/* OVERVIEW */}
            <Typography
                sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    opacity: 0.6,
                    mb: 1,
                    ml: 1,
                }}
            >
                GERAL
            </Typography>

            <List sx={{ p: 0 }}>
                {/* Dashboard */}
                <ListItemButton
                    component={Link}
                    to="/admin"
                    sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        py: 1.2,
                        background: isActive("/admin") ? "rgba(28, 100, 242, 0.12)" : "",
                        color: isActive("/admin") ? "var(--azul)" : "#555",
                    }}
                >
                    <ListItemIcon
                        sx={{
                            color: isActive("/admin") ? "var(--azul)" : "#777",
                            minWidth: 38,
                        }}
                    >
                        <MdDashboard size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>
            </List>

            <Divider sx={{ my: 2 }} />

            {/* MANAGEMENT */}
            <Typography
                sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    opacity: 0.6,
                    mb: 1,
                    ml: 1,
                }}
            >
                GESTÃO
            </Typography>

            <List sx={{ p: 0 }}>

                {/* SUBMENU: PRODUCTS*/}
                <ListItemButton
                    onClick={() => setOpenProducts(!openProducts)}
                    sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        py: 1.2,
                    }}
                >
                    <ListItemIcon sx={{ color: "#777", minWidth: 38 }}>
                        <MdShoppingBag size={20} />
                    </ListItemIcon>

                    <ListItemText
                        primary="Produtos"
                        primaryTypographyProps={{ fontSize: 15 }}
                    />

                    {openProducts ? (
                        <MdExpandLess size={20} />
                    ) : (
                        <MdExpandMore size={20} />
                    )}
                </ListItemButton>

                {/* SUBMENU INTERNO */}
                <Collapse in={openProducts} timeout="auto" unmountOnExit>
                    <List sx={{ pl: 4 }}>
                        {/* Listar produtos */}
                        <ListItemButton
                            component={Link}
                            to="/admin/produtos"
                            sx={{
                                borderRadius: 2,
                                mb: 0.5,
                                background: isActive("/admin/produtos") ? "rgba(28,100,242,0.12)" : "",
                            }}
                        >
                            <ListItemIcon sx={{ color: "#777", minWidth: 34 }}>
                                <MdList size={18} />
                            </ListItemIcon>
                            <ListItemText primary="Listar Produtos" />
                        </ListItemButton>

                        {/* Criar produto */}
                        <ListItemButton
                            component={Link}
                            to="/admin/produtos/novo"
                            sx={{
                                borderRadius: 2,
                                background: isActive("/admin/produtos/novo") ? "rgba(28,100,242,0.12)" : "",
                            }}
                        >
                            <ListItemIcon sx={{ color: "#777", minWidth: 34 }}>
                                <MdAdd size={18} />
                            </ListItemIcon>
                            <ListItemText primary="Criar Produto" />
                        </ListItemButton>
                    </List>
                </Collapse>

                {/* PEDIDOS */}
                <ListItemButton
                    component={Link}
                    to="/admin/pedidos"
                    sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        py: 1.2,
                        background: isActive("/admin/pedidos") ? "rgba(28,100,242,0.12)" : "",
                        color: isActive("/admin/pedidos") ? "var(--azul)" : "#555",
                    }}
                >
                    <ListItemIcon
                        sx={{ color: isActive("/admin/pedidos") ? "var(--azul)" : "#777", minWidth: 38 }}
                    >
                        <MdShoppingCart size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Pedidos" />
                </ListItemButton>

                {/* USUÁRIOS */}
                <ListItemButton
                    component={Link}
                    to="/admin/usuarios"
                    sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        py: 1.2,
                        background: isActive("/admin/usuarios") ? "rgba(28,100,242,0.12)" : "",
                        color: isActive("/admin/usuarios") ? "var(--azul)" : "#555",
                    }}
                >
                    <ListItemIcon
                        sx={{ color: isActive("/admin/usuarios") ? "var(--azul)" : "#777", minWidth: 38 }}
                    >
                        <MdPeople size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Usuários" />
                </ListItemButton>

                {/* MENSAGENS */}
                <ListItemButton
                    component={Link}
                    to="/admin/mensagens"
                    sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        py: 1.2,
                        background: isActive("/admin/mensagens") ? "rgba(28,100,242,0.12)" : "",
                        color: isActive("/admin/mensagens") ? "var(--azul)" : "#555",
                    }}
                >
                    <ListItemIcon
                        sx={{ color: isActive("/admin/mensagens") ? "var(--azul)" : "#777", minWidth: 38 }}
                    >
                        <IoMdMail size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Mensagens" />
                </ListItemButton>

                {/* CONFIGURAÇÕES */}
                <ListItemButton
                    component={Link}
                    to="/admin/configuracoes"
                    sx={{
                        borderRadius: 2,
                        py: 1.2,
                        background: isActive("/admin/configuracoes") ? "rgba(28,100,242,0.12)" : "",
                        color: isActive("/admin/configuracoes") ? "var(--azul)" : "#555",
                    }}
                >
                    <ListItemIcon
                        sx={{ color: isActive("/admin/configuracoes") ? "var(--azul)" : "#777", minWidth: 38 }}
                    >
                        <MdSettings size={20} />
                    </ListItemIcon>
                    <ListItemText primary="Configurações" />
                </ListItemButton>

            </List>
        </Box>
    );
}
